import { Link } from 'react-router-dom';
import { SITE } from '@/constants/site';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center bg-secondary-100 text-secondary-900">
                <i className="ri-radar-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{SITE.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">{SITE.description}</p>
            <p className="mt-4 text-sm text-secondary-300">
              <i className="ri-mail-line mr-2" aria-hidden="true" />
              <a href={`mailto:${SITE.email}`} className="text-secondary-100 underline decoration-secondary-500 underline-offset-4">
                {SITE.email}
              </a>
            </p>
          </div>

          {SITE.footerGroups.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-bold text-background-50">{group.title}</h3>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-200 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {SITE.since}–{year} {SITE.name} · {SITE.tagline}
          </p>
          <p className="text-secondary-400">
            站内话题均为公开讨论与信息整理，不构成对任何个人的事实认定
          </p>
        </div>
      </div>
    </footer>
  );
}